import moment from "moment/moment";
import { SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";
import { TRUE } from "../utils/const/bool-const";

export async function obtenerListaTipoChecklist(combo = false) {
    try {
        let rows = [];
        let { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/tipo-checklist/obtener-lista-tipo-checklist/",
            {
                headers: getHeaders(),
                method: "POST",
                // body: JSON.stringify({data: 'hello'}),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            if (combo === true) {
                for (let i = 0; i < body.length; i++) {
                    const element = body[i];
                    let obj = {};
                    obj.value = element.id;
                    obj.label = element.descripcion;
                    rows.push(obj);
                }
            }
            if (combo === false) {
                for (let i = 0; i < body.length; i++) {
                    body[i].fechaProceso = moment(body[i].fechaProceso).format('DD/MM/YYYY HH:mm');
                    body[i].manejoDefensivoLabel = body[i].manejoDefensivo === TRUE ? "SI" : "NO";
                    body[i].viajeLabel = body[i].viaje === TRUE ? "SI" : "NO";
                    rows.push(body[i]);
                }
            }
        }
        return rows;
    } catch (err) {
        console.log("obtenerListaTipoChecklist err");
        console.log(err);
        return [];
    }
}

export async function crearTipoChecklist(obj) {
    try {
        let creado = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/tipo-checklist/guardar-tipo-checklist/",
            {
                headers: getHeaders(),
                method: "POST",
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            creado = true;
        }
        return creado;
    } catch (err) {
        console.log("crearTipoChecklist err");
        console.log(err);
        return false;
    }
}

export async function modificarTipoChecklist(obj) {
    try {
        let modificado = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/tipo-checklist/modificar-tipo-checklist/",
            {
                headers: getHeaders(),
                method: "PUT",
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            modificado = true;
        }
        return modificado;
    } catch (err) {
        console.log("modificarTipoChecklist err");
        console.log(err);
        return false;
    }
}

export async function deshabilitarTipoChecklist(obj) {
    try {
        let result = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/tipo-checklist/deshabilitar-tipo-checklist/",
            {
                headers: getHeaders(),
                method: "PUT",
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            result = true;
        }
        return result;
    } catch (err) {
        console.log("deshabilitarTipoChecklist err");
        console.log(err);
        return false;
    }
}
